'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = Search;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _formSerialize = require('form-serialize');

var _formSerialize2 = _interopRequireDefault(_formSerialize);

function Search() {
	var _header = document.querySelector('#main-header'),
	    _btSearch = _header.querySelector('.icon-zoom'),
	    _body = document.querySelector('body'),
	    _searchForm = document.querySelector('.search-form');

	if (!_btSearch || !_searchForm) return;

	var addHandlers = function addHandlers() {
		_btSearch.addEventListener('click', clickSearch);
		_pubsub2['default'].on('search:close', function () {
			(0, _domClasslist2['default'])(_body).remove('search-opened');
		});
	};

	var clickSearch = function clickSearch(e) {
		e.preventDefault();
		(0, _domClasslist2['default'])(_body).toggle('search-opened');
		//pubsub.emit('newsletter:close')
	};

	var submitForm = function submitForm() {};

	addHandlers();
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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